import { SxProps, Theme } from '@mui/material';

type TStyles = {
  container: SxProps<Theme>;
  iframe: SxProps<Theme>;
  openButton: SxProps<Theme>;
};

export const styles: TStyles = {
  container: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    p: 1.5,
    bgcolor: 'background.default',
    color: 'text.secondary',
    border: '2px solid',
    borderColor: 'text.secondary',
    borderRadius: '10px',
    [theme.breakpoints.down(820)]: {
      border: 'none',
      borderRadius: 0,
      p: 0,
      bgcolor: 'transparent',
    },
  }),
  iframe: (theme: Theme) => ({
    width: '100%',
    height: '600px',
    border: 'none',
    [theme.breakpoints.down(820)]: {
      display: 'none',
    },
  }),
  openButton: (theme: Theme) => ({
    mt: 2,
    minWidth: '280px',
    alignSelf: 'center',
    [theme.breakpoints.down(820)]: {
      mt: 0,
    },
  }),
};
